import { Alert } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { http } from '@/shared/api/http';
import { keys } from '@/shared/api/queryKeys';

interface Health { status: string; worker: 'ok' | 'stale'; alerts: { key: string; message: string }[] }

/** One line at the top of every page while something that stops calls is wrong; nothing when all is well. */
export function SystemBanner() {
  const health = useQuery({
    queryKey: keys.health,
    queryFn: async () => (await http.get<Health>('/health')).data,
    refetchInterval: 30_000,
    retry: false,
  });
  if (health.isError) return <Alert severity="error" square>The server is not answering. Nothing is being called or scored right now.</Alert>;
  const raised = health.data?.alerts ?? [];
  if (!raised.length) return null;
  return <Alert severity="warning" square role="status">{raised.map((a) => a.message).join(' ')}</Alert>;
}
